export default __webpack_public_path__ + "static/media/it green.6c55d738.png";